(function () {
  "use strict";

  var root = document.getElementById("studio");
  if (!root) return;

  var API = (root.getAttribute("data-roster") || "").replace(/\/$/, "");
  var PIN_KEY = "moc-studio-pin";
  var pin = "";
  try {
    pin = sessionStorage.getItem(PIN_KEY) || "";
  } catch (err) {
    pin = "";
  }

  var state = { loading: false, error: "", data: null, started: false, saving: false };
  var robotsTag = null;

  function isStudio() {
    var hash = (location.hash || "").toLowerCase();
    if (hash === "#studio") return true;
    return /(?:^|[?&])studio(?:=1)?(?:&|$)/i.test(location.search);
  }

  function startStudio() {
    if (!robotsTag) {
      try {
        robotsTag = document.createElement("meta");
        robotsTag.name = "robots";
        robotsTag.content = "noindex, nofollow";
        document.head.appendChild(robotsTag);
      } catch (err) {
        robotsTag = null;
      }
    }
    hidePublicClasses();
    if (!state.started) {
      state.started = true;
      if (pin) load();
      else render();
    }
  }

  function stopStudio() {
    showPublicClasses();
    state.started = false;
    state.data = null;
    state.error = "";
    state.loading = false;
    root.innerHTML = "";
  }

  function syncMode() {
    if (isStudio()) startStudio();
    else stopStudio();
  }

  window.addEventListener("hashchange", syncMode);
  window.addEventListener("popstate", syncMode);
  syncMode();

  function hidePublicClasses() {
    var page = document.querySelector(".moc-page.moc-classes");
    if (page) {
      Array.prototype.forEach.call(page.children, function (child) {
        if (child.id !== "studio") child.hidden = true;
      });
    }
    Array.prototype.forEach.call(document.querySelectorAll(".shopify-section"), function (section) {
      if (section.querySelector("#studio")) return;
      if (section.querySelector(".moc-nav") || section.querySelector(".moc-footer")) return;
      section.hidden = true;
    });
    root.hidden = false;
  }

  function showPublicClasses() {
    var page = document.querySelector(".moc-page.moc-classes");
    if (page) {
      Array.prototype.forEach.call(page.children, function (child) {
        if (child.id === "studio") child.hidden = true;
        else child.hidden = false;
      });
    }
    Array.prototype.forEach.call(document.querySelectorAll(".shopify-section"), function (section) {
      section.hidden = false;
    });
    root.hidden = true;
  }

  function esc(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (char) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
    });
  }

  function displayDate(iso) {
    var bits = String(iso).split("-").map(Number);
    if (bits.length < 3 || !bits[0]) return iso;
    var dt = new Date(Date.UTC(bits[0], bits[1] - 1, bits[2]));
    return new Intl.DateTimeFormat("en-IE", {
      weekday: "long",
      day: "numeric",
      month: "long",
    }).format(dt);
  }

  function paidLabel(booking) {
    if (booking.paid) return "Paid";
    if (booking.status === "pending-payment" || booking.payment === "pay now") return "Pending payment";
    return "Due in person";
  }

  function headers(extra) {
    var out = { Accept: "application/json" };
    if (extra) Object.assign(out, extra);
    if (pin) out["x-moc-pin"] = pin;
    return out;
  }

  async function api(path, options) {
    if (!API) throw new Error("The class list is not connected yet.");
    options = options || {};
    var response = await fetch(API + path, {
      method: options.method || "GET",
      headers: headers(options.headers),
      body: options.body,
      cache: "no-store",
    });
    if (response.status === 401) {
      pin = "";
      try {
        sessionStorage.removeItem(PIN_KEY);
      } catch (err) {
        /* ignore */
      }
      var err = new Error("That PIN is not right.");
      err.code = "pin";
      throw err;
    }
    if (!response.ok) {
      var payload = {};
      try {
        payload = await response.json();
      } catch (parseErr) {
        payload = {};
      }
      throw new Error(payload.error || "Could not load the class list.");
    }
    return response;
  }

  async function load() {
    state.loading = true;
    state.error = "";
    render();
    try {
      var response = await api("/roster");
      state.data = await response.json();
    } catch (err) {
      state.data = null;
      if (err.code === "pin") {
        state.error = "That PIN is not right.";
      } else if (
        err.name === "TypeError" ||
        /failed to fetch|networkerror|load failed|network request failed/i.test(String(err.message || ""))
      ) {
        state.error = "Could not reach the class list. Tap Try again in a moment.";
      } else {
        state.error = err.message || "Could not load the class list.";
      }
    }
    state.loading = false;
    render();
  }

  async function patchPaid(id, paid) {
    await api("/paid", {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: id, paid: paid }),
    });
    await load();
  }

  async function sendConfirmation(id) {
    await api("/confirm-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: id }),
    });
    state.error = "";
    await load();
  }

  async function addWalkIn(event) {
    event.preventDefault();
    var name = document.getElementById("moc-add-name").value.trim();
    var email = document.getElementById("moc-add-email").value.trim();
    var phone = document.getElementById("moc-add-phone").value.trim();
    var date = document.getElementById("moc-add-date").value;
    var timeSlot = document.getElementById("moc-add-time").value;
    var paid = document.getElementById("moc-add-paid").checked;
    if (!name || !date) {
      state.error = "Name and Tuesday are needed to add someone.";
      render();
      return;
    }
    state.saving = true;
    state.error = "";
    render();
    try {
      await api("/walkin", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: name,
          email: email,
          phone: phone,
          dates: [date],
          timeSlot: timeSlot,
          paid: paid,
          passLabel: "Added in studio",
        }),
      });
      await load();
    } catch (err) {
      state.saving = false;
      state.error = err.message || "Could not add that name.";
      render();
    }
    state.saving = false;
  }

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function upcomingTuesdays(count) {
    var now = new Date();
    var dublin = new Intl.DateTimeFormat("en-IE", {
      timeZone: "Europe/Dublin",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(now);
    var get = function (type) {
      var part = dublin.find(function (item) {
        return item.type === type;
      });
      return part ? Number(part.value) : 0;
    };
    var iso = get("year") + "-" + pad(get("month")) + "-" + pad(get("day"));
    var bits = iso.split("-").map(Number);
    var weekday = new Date(Date.UTC(bits[0], bits[1] - 1, bits[2])).getUTCDay();
    var daysUntilTuesday = (2 - weekday + 7) % 7;
    var cursor = new Date(Date.UTC(bits[0], bits[1] - 1, bits[2] + daysUntilTuesday));
    var dates = [];
    while (dates.length < count) {
      dates.push(
        cursor.getUTCFullYear() + "-" + pad(cursor.getUTCMonth() + 1) + "-" + pad(cursor.getUTCDate()),
      );
      cursor.setUTCDate(cursor.getUTCDate() + 7);
    }
    return dates;
  }

  function downloadCsv() {
    var bookings = (state.data && state.data.bookings) || [];
    var rows = [
      ["Reference", "Name", "Email", "Phone", "Pass", "Time", "Dates", "Amount", "Paid", "Payment", "Status"],
      ...bookings.map(function (booking) {
        return [
          booking.id,
          booking.name,
          booking.email,
          booking.phone,
          booking.passLabel,
          booking.timeLabel,
          (booking.dates || []).join(" "),
          String(booking.amountEuro),
          booking.paid ? "yes" : booking.status === "pending-payment" || booking.payment === "pay now" ? "pending" : "no",
          booking.payment,
          booking.status,
        ];
      }),
    ];
    var csv = rows
      .map(function (row) {
        return row
          .map(function (cell) {
            return '"' + String(cell).replaceAll('"', '""') + '"';
          })
          .join(",");
      })
      .join("\n");
    var blob = new Blob([csv], { type: "text/csv" });
    var link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "moc-class-roster.csv";
    link.click();
    URL.revokeObjectURL(link.href);
  }

  function liveBookings() {
    return ((state.data && state.data.bookings) || []).filter(function (booking) {
      return booking.status !== "cancelled";
    });
  }

  function grouped() {
    var map = {};
    liveBookings().forEach(function (booking) {
      (booking.dates || []).forEach(function (date) {
        if (!map[date]) map[date] = [];
        map[date].push(booking);
      });
    });
    return Object.keys(map)
      .sort()
      .map(function (date) {
        return { date: date, people: map[date] };
      });
  }

  function peopleFor(session, label) {
    var slotId = label === "6:15pm" ? "18:15" : "19:15";
    return session.people.filter(function (booking) {
      return booking.timeLabel === label || booking.timeSlot === slotId;
    });
  }

  function pinForm() {
    return (
      '<span class="section-eyebrow">Studio</span>' +
      '<h1 class="section-title">Class list</h1>' +
      '<p class="moc-class-body">Sign in with the studio PIN to see who booked, which Tuesdays, and whether they have paid.</p>' +
      '<form id="moc-roster-pin" class="moc-roster-pin">' +
      '<div class="form-group"><label class="form-label" for="moc-pin">PIN</label>' +
      '<input id="moc-pin" class="form-input" type="password" autocomplete="current-password" required></div>' +
      (state.error ? '<p class="booker-alert booker-alert--error">' + esc(state.error) + "</p>" : "") +
      '<button type="submit" class="btn-primary">Open list</button></form>'
    );
  }

  function connectionError() {
    return (
      '<span class="section-eyebrow">Studio</span>' +
      '<h1 class="section-title">Class list</h1>' +
      '<p class="booker-alert booker-alert--error">' +
      esc(state.error || "Could not open the class list.") +
      "</p>" +
      '<p class="moc-class-body">This is the list itself, not the bookings. Test bookings still go to your email, and pay-now bookings are in Shopify orders. Try again, or add a name below once the list is connected.</p>' +
      '<div class="hero-btns moc-roster-actions">' +
      '<button type="button" class="btn-primary" id="moc-roster-retry">Try again</button>' +
      '<button type="button" class="btn-outline" id="moc-roster-out">Sign out</button></div>'
    );
  }

  function tableFor(people) {
    if (!people.length) return '<p class="status-line">No bookings yet.</p>';
    var rows = people
      .map(function (booking) {
        return (
          "<tr>" +
          "<td><strong>" +
          esc(booking.name) +
          '</strong><div class="choice-meta">' +
          esc(booking.id) +
          "</div></td>" +
          "<td>" +
          esc(booking.passLabel) +
          (booking.notes ? '<div class="choice-meta">' + esc(booking.notes) + "</div>" : "") +
          "</td>" +
          "<td><a href=\"mailto:" +
          esc(booking.email) +
          '">' +
          esc(booking.email) +
          '</a><div class="choice-meta">' +
          esc(booking.phone) +
          "</div></td>" +
          '<td><span class="pill' +
          (booking.paid ? " pill--ok" : "") +
          '">' +
          paidLabel(booking) +
          "</span></td>" +
          "<td><button type='button' class='btn-outline moc-roster-paid' data-id='" +
          esc(booking.id) +
          "' data-paid='" +
          (booking.paid ? "1" : "0") +
          "'>" +
          (booking.paid ? "Mark unpaid" : "Mark paid") +
          "</button>" +
          (booking.email
            ? "<button type='button' class='btn-outline moc-roster-email' data-id='" +
              esc(booking.id) +
              "'>Send confirmation</button>"
            : "") +
          "</td>" +
          "</tr>"
        );
      })
      .join("");
    return (
      '<div class="moc-roster-scroll"><table class="admin-table"><thead><tr>' +
      "<th>Name</th><th>Pass</th><th>Contact</th><th>Paid</th><th></th>" +
      "</tr></thead><tbody>" +
      rows +
      "</tbody></table></div>"
    );
  }

  function addForm() {
    var options = upcomingTuesdays(16)
      .map(function (iso) {
        return '<option value="' + esc(iso) + '">' + esc(displayDate(iso)) + "</option>";
      })
      .join("");
    return (
      '<section class="moc-roster-day moc-roster-add">' +
      '<h2 class="session-head">Add a name</h2>' +
      '<p class="moc-class-body">Use this for a walk-in, or to put someone on the list from an email if they are missing.</p>' +
      (state.error && state.data
        ? '<p class="booker-alert booker-alert--error">' + esc(state.error) + "</p>"
        : "") +
      '<form id="moc-roster-add" class="moc-roster-add-form">' +
      '<div class="form-group"><label class="form-label" for="moc-add-name">Name</label>' +
      '<input id="moc-add-name" class="form-input" type="text" autocomplete="name" required></div>' +
      '<div class="moc-roster-add-grid">' +
      '<div class="form-group"><label class="form-label" for="moc-add-email">Email (optional)</label>' +
      '<input id="moc-add-email" class="form-input" type="email" autocomplete="email"></div>' +
      '<div class="form-group"><label class="form-label" for="moc-add-phone">Phone (optional)</label>' +
      '<input id="moc-add-phone" class="form-input" type="tel" autocomplete="tel"></div>' +
      '</div>' +
      '<div class="moc-roster-add-grid">' +
      '<div class="form-group"><label class="form-label" for="moc-add-date">Tuesday</label>' +
      '<select id="moc-add-date" class="form-input">' +
      options +
      "</select></div>" +
      '<div class="form-group"><label class="form-label" for="moc-add-time">Time</label>' +
      '<select id="moc-add-time" class="form-input">' +
      '<option value="18:15">6:15pm</option>' +
      '<option value="19:15">7:15pm</option>' +
      "</select></div></div>" +
      '<label class="moc-roster-check"><input id="moc-add-paid" type="checkbox"> Already paid</label>' +
      '<button type="submit" class="btn-primary"' +
      (state.saving ? " disabled" : "") +
      ">" +
      (state.saving ? "Adding…" : "Add to list") +
      "</button></form></section>"
    );
  }

  function rosterView() {
    var live = liveBookings();
    var sessions = grouped();
    var html =
      '<span class="section-eyebrow">Studio</span>' +
      '<h1 class="section-title">Class list</h1>' +
      '<p class="moc-class-body">' +
      live.length +
      " live " +
      (live.length === 1 ? "booking" : "bookings") +
      ". Pay now on the website shows as Paid after the card payment goes through. Until then it is Pending payment. Pay in person at Balla — tap Mark paid. If a name is missing, it still arrived by email; add it below.</p>" +
      '<div class="hero-btns moc-roster-actions">' +
      '<button type="button" class="btn-outline" id="moc-roster-csv">Download CSV</button>' +
      '<button type="button" class="btn-outline" id="moc-roster-out">Sign out</button></div>';

    if (state.loading) html += '<p class="status-line">Opening the list…</p>';
    else if (!sessions.length)
      html +=
        '<p class="status-line">Nobody is on this list yet. New bookings should appear here. Older tests are in your email and in Shopify if they paid on the website — add them below if you still need them on the list.</p>';

    sessions.forEach(function (session) {
      html += '<section class="moc-roster-day"><h2 class="session-head">' + esc(displayDate(session.date)) + "</h2>";
      ["6:15pm", "7:15pm"].forEach(function (label) {
        var people = peopleFor(session, label);
        html +=
          '<div class="moc-roster-slot"><p class="section-eyebrow">' +
          label +
          " · " +
          people.length +
          "/12" +
          (people.length >= 12 ? " · Full" : " booked") +
          "</p>" +
          tableFor(people) +
          "</div>";
      });
      html += "</section>";
    });

    html += addForm();

    var all = (state.data && state.data.bookings) || [];
    html +=
      '<section class="moc-roster-day"><h2 class="session-head">Every booking</h2>' +
      '<div class="moc-roster-scroll"><table class="admin-table"><thead><tr>' +
      "<th>Reference</th><th>Name</th><th>Tuesdays</th><th>Paid</th></tr></thead><tbody>";
    if (!all.length) {
      html += '<tr><td colspan="4">No bookings on this list yet.</td></tr>';
    } else {
      all.forEach(function (booking) {
        html +=
          "<tr><td>" +
          esc(booking.id) +
          "</td><td>" +
          esc(booking.name) +
          (booking.status === "cancelled" ? ' <span class="choice-meta">cancelled</span>' : "") +
          "</td><td>" +
          esc((booking.dates || []).map(displayDate).join(", ")) +
          " · " +
          esc(booking.timeLabel) +
          "</td><td>" +
          paidLabel(booking).toLowerCase() +
          "</td></tr>";
      });
    }
    html += "</tbody></table></div></section>";
    return html;
  }

  function bind() {
    var form = document.getElementById("moc-roster-pin");
    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        pin = document.getElementById("moc-pin").value;
        try {
          sessionStorage.setItem(PIN_KEY, pin);
        } catch (err) {
          /* ignore */
        }
        load();
      });
    }
    var csvBtn = document.getElementById("moc-roster-csv");
    if (csvBtn) csvBtn.addEventListener("click", downloadCsv);
    var outBtn = document.getElementById("moc-roster-out");
    if (outBtn) {
      outBtn.addEventListener("click", function () {
        pin = "";
        state.data = null;
        state.error = "";
        try {
          sessionStorage.removeItem(PIN_KEY);
        } catch (err) {
          /* ignore */
        }
        render();
      });
    }
    var add = document.getElementById("moc-roster-add");
    if (add) add.addEventListener("submit", addWalkIn);
    var retryBtn = document.getElementById("moc-roster-retry");
    if (retryBtn) retryBtn.addEventListener("click", load);
    Array.prototype.forEach.call(root.querySelectorAll(".moc-roster-paid"), function (button) {
      button.addEventListener("click", function () {
        var id = button.getAttribute("data-id");
        var paid = button.getAttribute("data-paid") !== "1";
        button.disabled = true;
        patchPaid(id, paid).catch(function (err) {
          state.error = err.message;
          render();
        });
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll(".moc-roster-email"), function (button) {
      button.addEventListener("click", function () {
        var id = button.getAttribute("data-id");
        button.disabled = true;
        sendConfirmation(id).catch(function (err) {
          state.error = err.message;
          render();
        });
      });
    });
  }

  function render() {
    if (!pin || state.error === "That PIN is not right.") {
      root.innerHTML = '<div class="moc-class-wide moc-roster-shell">' + pinForm() + "</div>";
      bind();
      return;
    }
    if (!state.data && !state.loading) {
      root.innerHTML = '<div class="moc-class-wide moc-roster-shell">' + connectionError() + "</div>";
      bind();
      return;
    }
    root.innerHTML = '<div class="moc-class-wide moc-roster-shell">' + rosterView() + "</div>";
    bind();
  }
})();
